import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import { usePromotedTrackingData } from '#src/app/shared/hooks/promotion';

export function usePromotedTrackingDataForCurrentPetition(): ReturnType<typeof usePromotedTrackingData> {
	const {
		data: {
			petition: { id },
		},
	} = usePetitionDetailsPageData();
	return usePromotedTrackingData(id);
}
